import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ImageReadyService } from './';
import { Subscription } from 'rxjs';
import { Observer } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
export interface FileRaw {
  approval: number;
  approvals: any[];
  approved: number;
  approvedHTML: string;
  approvedchanges: number;
  approvedchangesHTML: string;
  dateadded: Date;
  datemodified: Date;
  encryptedID: string;
  file: string;
  file2: string;
  googlethumbnail?: string;
  id: number;
  isgoogle?: number;
  legaltext?: string;
  mime: string;
  name: string;
  needs_signed: number;
  pasttenseApprovedChangesHTML?: string;
  pasttenseApprovedHTML?: string;
  pastenseRejectedHTML?: string;
  prelegaltext?: string;
  priority: number;
  production_ready: number;
  rejected: number;
  rejectedHTML: string;
  requiresalesperson: number;
  salespersonid: number;
  show_contact: number;
  show_contacts: number;
  show_needs_signed: number;
  show_production_ready: number;
  thumb: string;
  ticketid: number;
  typeid: number;
  typename: string;
  upload: number;
}

export interface FileResponse {
  files?: FileRaw[];
  file?: FileRaw;
  msg?: string;
  error: boolean;
}

export enum FileApprovalTypes {
  PENDING,
  REJECTED,
  APPROVEDCHANGES,
  APPROVED
}

@Injectable()
export class FilesProvider {
  private URL: string = `${environment.API_URL}file/`;
  constructor(
    public http: HttpClient,
    private irs: ImageReadyService
  ) { }

  getFileData(encryptedID: any) {
    return this.http.get(`${this.URL}data/${encryptedID}`).take(1);
  }

  getFile(encryptedID: any, meta: string, name: string = null) {
    /*return this.http.get(`${this.URL}view/${encryptedID}`, {responseType: 'arraybuffer'}).take(1).map(data => {
      console.log(data);
      return this.getBlob(data, meta);
    });*/

    return this.downloadFile(encryptedID).map(data => {
      return this.getBlob(data, meta)
    });
  }

  private getBlob(filedata: any, meta: string, name: string = null) {
    let blob = new Blob([filedata], {type: meta});
    if (name) {
      //blob.name = name;
    }
    return blob;
  }

  private downloadFile(encryptedID: any) {
    const observable = new Observable((observer: Observer<any>) => {
      const req = new HttpRequest('GET', `${this.URL}view/${encryptedID}`, {
        reportProgress: true,
        responseType: 'arraybuffer',
      });
      this.http.request(req).subscribe((event: any) => {
        if (event.type === HttpEventType.DownloadProgress) {
          if (event.total) {
            const percent = Math.round(100 * (event.loaded / event.total));
            this.irs.updateProgress(''+percent, encryptedID);
          }
        } else if (event.type === HttpEventType.Response) {
          observer.next(event.body);
          observer.complete();
        } else {
          // console.log('Unhandled event, please ignore.');
        }
      },
      (err: any) => {
        console.log('Error:', err);
      });
    });
    return observable;
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/files.provider.ts